const validate = value => {
  let regex = /^((\d{8}))$/
  if (!regex.test(value)) {
    return false
  }
  return true
}

export default {
  validate,
  getMessage: (field, args) => {
    return 'Reference number must contain 8 digits'
  }
}
